const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`<div id="signup-form-a">
  <div class="c-cloud-cover t-dark">
    <div class="o-container o-container--pad-inline">
      <div class="o-container__content c-cloud-cover__inner">
        <div class="c-cloud-cover__content">
          <div class="o-rhythm o-rhythm--condensed">
            <h1 class="c-heading c-heading--level-n2">Articles</h1>
            <p>Tales from the edge of the web</p>
          </div>
        </div>
        <div class="c-cloud-cover__extra">
          <label for="demo-input">Send weekly digests to...</label>
          <div class="demo-input-basic demo-input-button">
            <input
              type="text"
              value=""
              class="c-input"
              id="demo-input"
              placeholder="Example: you@somewhere.tld"
            />
            <button class="c-button" type="button">Subscribe</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
`);
            }

            getTemplateName() {
                return `4eab99e7809f7170c1b752cb65ffa3f72f3e5de913cf2765e677406db63896c8`;
            }

            getSourceContext() {
                return new this.Source(``, `4eab99e7809f7170c1b752cb65ffa3f72f3e5de913cf2765e677406db63896c8`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '4eab99e7809f7170c1b752cb65ffa3f72f3e5de913cf2765e677406db63896c8');

let template = env.loadTemplate('4eab99e7809f7170c1b752cb65ffa3f72f3e5de913cf2765e677406db63896c8');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/prototypes/email-signup/example/example-a.twig", args: context }
     );
     return rendered;;
};